import { render, staticRenderFns } from "./ManageAffiliationSettingsModal.vue?vue&type=template&id=a9fee860&scoped=true&"
import script from "./ManageAffiliationSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ManageAffiliationSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageAffiliationSettingsModal.vue?vue&type=style&index=0&id=a9fee860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fee860",
  null
  
)

component.options.__file = "ManageAffiliationSettingsModal.vue"
export default component.exports